<template>
    <div class="login-form text-center">
        <h1 class="font-normal text-[41.5px] mt-[108px]" id="welcome-message">
            {{ $t('login.welcome') }}
        </h1>
        <p class="font-normal text-[#515659] mb-[78px]" id="mgmt-message">
            {{ $t('login.managementTool') }}
        </p>
        <div
            class="bg-white border-2 border-gray-300 w-[420px] h-[250px] m-auto p-[30px]"
            id="login-box"
        >
            <h2 class="font-normal text-[24.5px] mb-8 mt-2" id="login-title">
                {{ $t('login.loginTitle') }}
            </h2>
            <v-btn variant="outlined" @click="login" height="80px" width="350px" id="login-button">
                <nanooSecurityLogo id="nanoo-security-logo" />
            </v-btn>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import nanooSecurityLogo from './nanooSecurityLogo.vue'

    function login() {
        window.location.href =
            process.env.VUE_APP_SDREAMLAND_BACKEND_URL + '/login/external/services/ms'
    }
</script>
